/* eslint-disable */
/* !!! THIS FILE WAS GENERATED BY GRAPHQL-CODE-GENERATOR !!!
* !!! DO NOT MODIFY THIS FILE BY YOURSELF  !!! */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Chat_DateScalar: { input: string; output: string; }
  CommerceV2_DateTime: { input: string; output: string; }
  CommerceV2_Price: { input: string; output: string; }
  DateScalar: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DateTimeISO: { input: any; output: any; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  ShopifyOrderID: { input: string; output: string; }
  ShopifyProductID: { input: string; output: string; }
  ShopifyProductVariantID: { input: string; output: string; }
  Voting_DateTime: { input: string; output: string; }
};

export type Affiliate = {
  __typename?: 'Affiliate';
  affiliateCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BaseCommissionPolicy = {
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['output'];
  /** The unique ID of the commission policy */
  id: Scalars['ID']['output'];
};

/** Object representing a STAGE TEN channel and its current state */
export type Channel = {
  __typename?: 'Channel';
  /** Aspect Ratio of broadcast (16:9 or 9:16) */
  aspectRatio?: Maybe<Scalars['String']['output']>;
  /** Banner image URL of the Channel */
  bannerUrl?: Maybe<Scalars['String']['output']>;
  /** Description for the current broadcast of the channel */
  broadcastDescription?: Maybe<Scalars['String']['output']>;
  /** ID for the current broadcast of the channel */
  broadcastId?: Maybe<Scalars['String']['output']>;
  /** Internal unique ID for broadcast WebRTC/HLS stream */
  broadcastStreamToken?: Maybe<Scalars['String']['output']>;
  /** Title for the current broadcast of the channel */
  broadcastTitle?: Maybe<Scalars['String']['output']>;
  /** Time Channel was created */
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Longer description of Channel */
  description?: Maybe<Scalars['String']['output']>;
  /** Url to obtain broadcast video from HLS */
  hlsUrl?: Maybe<Scalars['String']['output']>;
  /** Unique Internal ID for Channel */
  id: Scalars['ID']['output'];
  /** Is Channel currently live? */
  live?: Maybe<Scalars['Boolean']['output']>;
  /** Are Live Subtitles enabled on this Channel? */
  liveSubtitles?: Maybe<Scalars['Boolean']['output']>;
  /** Reconnect to the channel to handle backend update */
  reconnect?: Maybe<Scalars['Boolean']['output']>;
  /** List of scheduled shows for this channel */
  scheduledShows?: Maybe<Array<ScheduledShow>>;
  /** User friendly channel url element */
  slug?: Maybe<Scalars['String']['output']>;
  /** User provided Channel title */
  title?: Maybe<Scalars['String']['output']>;
  /** Time Channel was last updated */
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** The user this channel belongs to */
  user: User;
  /** Whether a watermark is displayed on this channel */
  watermarkOnPlayer?: Maybe<Scalars['Boolean']['output']>;
  /** Server URL for watch Janus server [DEPRECATED] */
  webrtcServer?: Maybe<Scalars['String']['output']>;
  /** Url to obtain broadcast video from  WebRTC */
  webrtcUrl?: Maybe<Scalars['String']['output']>;
};

export type Chat_Chat = {
  __typename?: 'Chat_Chat';
  /** An API key for programmatically sending messages. */
  apiKey?: Maybe<Scalars['String']['output']>;
  chatBans: Array<Chat_ChatBan>;
  /** An additional channel-specific list of words and phrases that are banned on exact match. */
  customBannedWords: Array<Scalars['String']['output']>;
  /** Whether the custom banned words filter is enabled. */
  customProfanityFilterEnabled: Scalars['Boolean']['output'];
  /** Global default list of words and phrases that are banned on exact match. */
  exactMatchBannedWords: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  /** Global default list of words and phrases that are banned on an exact or partial match. */
  partialMatchBannedWords: Array<Scalars['String']['output']>;
  /** Whether the default global banned words list is enabled. */
  profanityFilterEnabled: Scalars['Boolean']['output'];
};

export type Chat_ChatBan = {
  __typename?: 'Chat_ChatBan';
  createdAt: Scalars['Chat_DateScalar']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Chat_DateScalar']['output']>;
  id: Scalars['ID']['output'];
  /** The chat source of the user */
  sourceName: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/** An event relating to a chat ban */
export type Chat_ChatBanEvent = {
  __typename?: 'Chat_ChatBanEvent';
  /** The chat ban associated with the event */
  chatBan: Chat_ChatBan;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The type of event */
  type: Chat_ChatBanEventType;
};

export enum Chat_ChatBanEventType {
  ChatBanCreated = 'CHAT_BAN_CREATED',
  ChatBanDeleted = 'CHAT_BAN_DELETED'
}

/** An event relating to chat */
export type Chat_ChatEvent = {
  __typename?: 'Chat_ChatEvent';
  /** The chat associated with the event */
  chat: Chat_Chat;
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The type of event */
  type: Chat_ChatEventType;
};

export enum Chat_ChatEventType {
  ChatUpdated = 'CHAT_UPDATED'
}

export type Chat_GrantResult = {
  __typename?: 'Chat_GrantResult';
  hasWriteAccess: Scalars['Boolean']['output'];
  isBanned: Scalars['Boolean']['output'];
  pubnubAccessToken: Scalars['String']['output'];
  roomKey: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/** Represents a Plugin Instance for a given Channel */
export type Chat_Instance = {
  __typename?: 'Chat_Instance';
  channelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  publicChat: Chat_Chat;
};

/** Checkout LineItems */
export type CheckoutLineItem = {
  __typename?: 'CheckoutLineItem';
  fulfillmentService?: Maybe<Scalars['String']['output']>;
  grams?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  linePrice?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Int']['output'];
  requiresShipping?: Maybe<Scalars['Boolean']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  variantId: Scalars['Float']['output'];
  variantTitle?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export enum Client {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type Collection = {
  __typename?: 'Collection';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  products: ProductConnection;
  productsCount: Scalars['Int']['output'];
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};


export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  edges: Array<CollectionEdge>;
  pageInfo: PageInfo;
};

export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  cursor: Scalars['String']['output'];
  node: Collection;
};

export enum CommerceV2_CommerceProvider {
  Target = 'Target'
}

export type CommerceV2_CreatePreselectedVariantMappingInput = {
  productId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};

export type CommerceV2_CreateSaleInput = {
  preselectedVariantMappings?: InputMaybe<Array<CommerceV2_CreatePreselectedVariantMappingInput>>;
  productIds: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

/** Represents an ISO 4217 Currency Code: https://en.wikipedia.org/wiki/ISO_4217 */
export enum CommerceV2_CurrencyCode {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Czk = 'CZK',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gmd = 'GMD',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Isk = 'ISK',
  Jep = 'JEP',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Srd = 'SRD',
  Std = 'STD',
  Syp = 'SYP',
  Thb = 'THB',
  Tmt = 'TMT',
  Tnd = 'TND',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW'
}

export type CommerceV2_Image = {
  __typename?: 'CommerceV2_Image';
  altText?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CommerceV2_Instance = CommerceV2_Node & {
  __typename?: 'CommerceV2_Instance';
  activeSale?: Maybe<CommerceV2_Sale>;
  activeSaleId?: Maybe<Scalars['ID']['output']>;
  channelId: Scalars['ID']['output'];
  createdAt: Scalars['CommerceV2_DateTime']['output'];
  id: Scalars['ID']['output'];
  paymentSettings: CommerceV2_PaymentSettings;
  provider: CommerceV2_CommerceProvider;
  sales: CommerceV2_SalePage;
  updatedAt: Scalars['CommerceV2_DateTime']['output'];
};


export type CommerceV2_InstanceSalesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Base class for global object identification */
export type CommerceV2_Node = {
  id: Scalars['ID']['output'];
};

export type CommerceV2_PaymentSettings = {
  __typename?: 'CommerceV2_PaymentSettings';
  currencyCode: CommerceV2_CurrencyCode;
};

export type CommerceV2_PreselectedVariantMapping = CommerceV2_Node & {
  __typename?: 'CommerceV2_PreselectedVariantMapping';
  /** The timestamp when the mapping was created */
  createdAt: Scalars['CommerceV2_DateTime']['output'];
  /** The ID of the mapping */
  id: Scalars['ID']['output'];
  /** The Product ID of the mapping */
  productId: Scalars['String']['output'];
  /** The timestamp when the mapping was updated */
  updatedAt: Scalars['CommerceV2_DateTime']['output'];
  /** The Variant ID of the mapping */
  variantId: Scalars['String']['output'];
};

export type CommerceV2_PriceRange = {
  __typename?: 'CommerceV2_PriceRange';
  maxVariantPrice: Scalars['CommerceV2_Price']['output'];
  minVariantPrice: Scalars['CommerceV2_Price']['output'];
};

export type CommerceV2_Product = CommerceV2_Node & {
  __typename?: 'CommerceV2_Product';
  available: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<CommerceV2_Image>;
  id: Scalars['ID']['output'];
  /** Product property names like "Size", "Color", and "Material". Variants are based on permutations of these options */
  options: Array<CommerceV2_ProductOptions>;
  preselectedVariant: CommerceV2_ProductVariant;
  priceRange: CommerceV2_PriceRange;
  title: Scalars['String']['output'];
  totalInventory?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  variants: Array<CommerceV2_ProductVariant>;
};

export type CommerceV2_ProductOption = {
  __typename?: 'CommerceV2_ProductOption';
  name: Scalars['String']['output'];
  previewImage?: Maybe<CommerceV2_Image>;
  value: Scalars['String']['output'];
};

export type CommerceV2_ProductOptions = {
  __typename?: 'CommerceV2_ProductOptions';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CommerceV2_ProductVariant = CommerceV2_Node & {
  __typename?: 'CommerceV2_ProductVariant';
  available: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<CommerceV2_Image>;
  id: Scalars['ID']['output'];
  images: Array<CommerceV2_Image>;
  options: Array<CommerceV2_ProductOption>;
  price: Scalars['CommerceV2_Price']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CommerceV2_Sale = CommerceV2_Node & {
  __typename?: 'CommerceV2_Sale';
  /** The timestamp when the Sale was created */
  createdAt: Scalars['CommerceV2_DateTime']['output'];
  /** The Product ID which is featured in the Player */
  featuredProductId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the Sale is hidden */
  hidden: Scalars['Boolean']['output'];
  /** The ID of the Sale */
  id: Scalars['ID']['output'];
  /** The the parent Instance of the Sale */
  instance: CommerceV2_Instance;
  /** The preselected variant mappings for Products in the Sale */
  preselectedVariantMappings: Array<CommerceV2_PreselectedVariantMapping>;
  /** Resolve a product in the context of a Sale */
  product?: Maybe<CommerceV2_Product>;
  /** The Product IDs belonging to the Sale */
  productIds: Array<Scalars['ID']['output']>;
  /** The Products in the Sale */
  products: Array<CommerceV2_Product>;
  /** The title of the Sale */
  title: Scalars['String']['output'];
  /** The timestamp when the Sale was last updated */
  updatedAt: Scalars['CommerceV2_DateTime']['output'];
  /** The subset of Product IDs which are visible in the Player */
  visibleProductIds: Array<Scalars['ID']['output']>;
};


export type CommerceV2_SaleProductArgs = {
  id: Scalars['ID']['input'];
};

export type CommerceV2_SaleEvent = CommerceV2_Node & {
  __typename?: 'CommerceV2_SaleEvent';
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The Sale associated with the event */
  sale: CommerceV2_Sale;
  /** The type of the event */
  type: CommerceV2_SaleEventType;
};

export enum CommerceV2_SaleEventType {
  SaleCreated = 'SALE_CREATED',
  SaleDeleted = 'SALE_DELETED',
  SaleUpdated = 'SALE_UPDATED'
}

export type CommerceV2_SalePage = {
  __typename?: 'CommerceV2_SalePage';
  cursor?: Maybe<Scalars['String']['output']>;
  moreData: Scalars['Boolean']['output'];
  records: Array<CommerceV2_Sale>;
};

export type CommerceV2_UpdateSaleInput = {
  id: Scalars['ID']['input'];
  preselectedVariantMappings: Array<CommerceV2_CreatePreselectedVariantMappingInput>;
  productIds: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type CommissionPolicy = BaseCommissionPolicy & {
  __typename?: 'CommissionPolicy';
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['output'];
  /** The unique ID of the commission policy */
  id: Scalars['ID']['output'];
};

/** Represent a Connection to a STAGE TEN account */
export type Connection = {
  __typename?: 'Connection';
  /** @deprecated No longer used */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Replaced with Shop.channelId */
  channelId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateScalar']['output']>;
  /** @deprecated No longer used */
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated No longer used */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used */
  shopId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateScalar']['output']>;
  /** @deprecated No longer used */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ConnectionRequestResponse = {
  __typename?: 'ConnectionRequestResponse';
  hasExistingConnection: Scalars['Boolean']['output'];
};

export type ContentReportInput = {
  /** The category describing how this content is objectionable, given by the reporting user */
  category: Scalars['String']['input'];
  /** The description given by the reporting user */
  description: Scalars['String']['input'];
  /** The id of the channel being reported */
  id: Scalars['ID']['input'];
};

export type CreateSaleInput = {
  collectionIds: Array<Scalars['String']['input']>;
  /** A discount code for the Sale */
  discountCode?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CustomCommissionPolicy = BaseCommissionPolicy & {
  __typename?: 'CustomCommissionPolicy';
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['output'];
  /** The date when the custom commission policy was created */
  createdAt: Scalars['DateTime']['output'];
  /** A brief description of the custom commission policy */
  description?: Maybe<Scalars['String']['output']>;
  /** The date at which the custom commission policy will expire */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of the custom commission policy */
  id: Scalars['ID']['output'];
  /** The shop associated with the custom commission policy */
  shop: Shop;
  /** The date when the custom commission policy was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type DisablePluginInput = {
  options?: InputMaybe<Scalars['JSON']['input']>;
  /** Force the plugin to stay disabled at the start of any future broadcast */
  persistent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique key for the plugin to enable */
  pluginKey: Scalars['String']['input'];
};

export type DisablePluginsInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  plugins?: InputMaybe<Array<DisablePluginInput>>;
};

export type Discount = {
  __typename?: 'Discount';
  /** The discount code */
  code: Scalars['String']['output'];
  /** Whether the discount code exists */
  exists: Scalars['Boolean']['output'];
  /** Information about the discount */
  info?: Maybe<DiscountInfo>;
};

export type DiscountExpiredWarning = DiscountWarning & {
  __typename?: 'DiscountExpiredWarning';
  /** The code associated with the warning */
  code: DiscountWarningCode;
  /** The date and time when the discount expired */
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** A description of the warning */
  message: Scalars['String']['output'];
};

export type DiscountInfo = {
  __typename?: 'DiscountInfo';
  /** The date and time when the discount ends */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The URL of the discount within the Shopify admin */
  shopifyAdminUrl: Scalars['String']['output'];
  /** A short summary of the discount */
  shortSummary: Scalars['String']['output'];
  /** The date and time when the discount starts */
  startsAt: Scalars['DateTime']['output'];
  /** The status of the discount */
  status: DiscountStatus;
  /** A summary of the discount */
  summary: Scalars['String']['output'];
  /** Warnings about the discount */
  warnings: Array<DiscountWarning>;
};

export type DiscountNonApplicableWarning = DiscountWarning & {
  __typename?: 'DiscountNonApplicableWarning';
  /** The code associated with the warning */
  code: DiscountWarningCode;
  /** A description of the warning */
  message: Scalars['String']['output'];
  /** The product IDs in a Sale which aren't applicable for the discount */
  nonApplicableProductIds: Array<Scalars['String']['output']>;
};

/** The status of the discount */
export enum DiscountStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export type DiscountWarning = {
  /** The code associated with the warning */
  code: DiscountWarningCode;
  /** A description of the warning */
  message: Scalars['String']['output'];
};

/** The code associated with the warning */
export enum DiscountWarningCode {
  Expired = 'EXPIRED',
  NonApplicable = 'NON_APPLICABLE'
}

/** Whether a given resource is eligible for Shop Mini */
export enum EligibilityStatus {
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE'
}

export type EnablePluginInput = {
  options?: InputMaybe<Scalars['JSON']['input']>;
  /** Force the plugin to stay enabled at the end of the broadcast */
  persistent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique key for the plugin to enable */
  pluginKey: Scalars['String']['input'];
};

export type EnablePluginsInput = {
  broadcastId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  plugins: Array<EnablePluginInput>;
};

export type Image = {
  __typename?: 'Image';
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  originalSrc: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  edges: Array<ImageEdge>;
};

export type ImageEdge = {
  __typename?: 'ImageEdge';
  node: Image;
};

export type LineItem = {
  __typename?: 'LineItem';
  id: Scalars['String']['output'];
  product?: Maybe<Product>;
  quantity: Scalars['Int']['output'];
  variant?: Maybe<ProductVariant>;
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  amount: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateSale: Shop;
  /** Bans a user from public chat */
  chat_banUserFromPublicChat: Chat_ChatBan;
  /** Updates preferences for public chat */
  chat_regenerateApiKey: Chat_Instance;
  /** Unbans a user from public chat */
  chat_unbanUserFromPublicChat?: Maybe<Chat_ChatBan>;
  /** Updates preferences for public chat */
  chat_updatePublicChatPreferences: Chat_Instance;
  /** @deprecated Completed checkouts are now detected using webhooks */
  checkoutCompleted: Scalars['Boolean']['output'];
  clearFeaturedItem: Sale;
  commerceV2_activateSale: CommerceV2_Instance;
  /** Create a new sale */
  commerceV2_createSale: CommerceV2_Sale;
  commerceV2_deactivateSale: CommerceV2_Instance;
  /** Delete an existing sale */
  commerceV2_deleteSale?: Maybe<Scalars['ID']['output']>;
  /** Update an existing sale */
  commerceV2_updateSale: CommerceV2_Sale;
  /** Update a sale's featured product */
  commerceV2_updateSaleFeaturedProduct: CommerceV2_Sale;
  /** Update a sale's product IDs */
  commerceV2_updateSaleProductIds: CommerceV2_Sale;
  /** Update a sale's title */
  commerceV2_updateSaleTitle: CommerceV2_Sale;
  /** Update a sale's visible product IDs */
  commerceV2_updateSaleVisibleProductIds: CommerceV2_Sale;
  contentReport: Scalars['Boolean']['output'];
  /** @deprecated Replaced with createConnectionRequestV2 */
  createConnectionRequest: ConnectionRequestResponse;
  createConnectionRequestV2: ConnectionRequestResponse;
  createSale: Sale;
  deactivateSale: Shop;
  /** @deprecated Temporary endpoint for initial development */
  deleteAllSalesOnShop: Shop;
  /** @deprecated Replaced with deleteConnectionV2 which resolves a Shop */
  deleteConnection: Scalars['Boolean']['output'];
  deleteConnectionV2?: Maybe<Shop>;
  /** Deletes the custom commission policy for a shop */
  deleteCustomCommissionPolicyForShop: Shop;
  deleteSale: Sale;
  /** Disable one or more plugins on a particular channel. */
  disablePlugins: Array<Plugin>;
  /** Enable one or more plugins on a particular channel. */
  enablePlugins: Array<Plugin>;
  featureCollection: Sale;
  featureProduct: Sale;
  productsAddedToCart: Scalars['Boolean']['output'];
  /** Sets whether the Shop Mini entrypoint should be hidden when the broadcast on the associated output is ended */
  setHideShopMiniEntrypointOnBroadcastEnd: Shop;
  setOnboardingState: Shop;
  /** Sets the internal enabled/disabled state of the Shop Mini */
  setShopMiniEnabled: Shop;
  /** Sets whether Shop Mini push notifications should be triggered when a broadcast is started */
  setShopMiniPushNotificationsEnabled: Shop;
  /** Creates a shopping cart filled with the specified items */
  target_createCart: Scalars['String']['output'];
  /** Trigger Shop Mini cleanup jobs for a specific shop */
  triggerShopMiniCleanupJobForShop: Scalars['Boolean']['output'];
  /** Trigger Shop Mini cleanup jobs */
  triggerShopMiniCleanupJobs: Scalars['Boolean']['output'];
  updateCollectionVisibility: Sale;
  /** Update the current playback timing state. See the documentation for PlaybackTimingState for the parameter definitions. */
  updatePlaybackTiming: PlaybackTimingState;
  /** Update one or more plugins on a particular channel. */
  updatePlugins: Array<Plugin>;
  updateProductVisibility: Sale;
  updateSale: Sale;
  /** Updates properties of the Event Card entrypoint for Shop Mini */
  updateShopMiniEntrypoint: Shop;
  updateShopPreferences: Shop;
  /** Upserts the custom commission policy for a shop */
  upsertCustomCommissionPolicyForShop: Shop;
  voting_activateQuestion: Scalars['Boolean']['output'];
  voting_castVote: Scalars['Boolean']['output'];
  voting_createQuestion?: Maybe<Voting_Question>;
  voting_deactivateQuestion: Scalars['Boolean']['output'];
  voting_deleteQuestion: Scalars['String']['output'];
  /** Resets votes for all questions */
  voting_resetAllVotes: Array<Voting_Question>;
  /** Resets votes for a question */
  voting_resetVotes: Voting_Question;
  voting_updateQuestion: Voting_Question;
};


export type MutationActivateSaleArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationChat_BanUserFromPublicChatArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  sourceName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChat_UnbanUserFromPublicChatArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  sourceName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChat_UpdatePublicChatPreferencesArgs = {
  customBannedWords?: InputMaybe<Array<Scalars['String']['input']>>;
  customProfanityFilterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  profanityFilterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCheckoutCompletedArgs = {
  orderId: Scalars['ShopifyOrderID']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationClearFeaturedItemArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCommerceV2_ActivateSaleArgs = {
  saleId: Scalars['ID']['input'];
};


export type MutationCommerceV2_CreateSaleArgs = {
  input: CommerceV2_CreateSaleInput;
};


export type MutationCommerceV2_DeleteSaleArgs = {
  id: Scalars['String']['input'];
};


export type MutationCommerceV2_UpdateSaleArgs = {
  input: CommerceV2_UpdateSaleInput;
};


export type MutationCommerceV2_UpdateSaleFeaturedProductArgs = {
  featuredProductId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCommerceV2_UpdateSaleProductIdsArgs = {
  id: Scalars['ID']['input'];
  productIds: Array<Scalars['ID']['input']>;
};


export type MutationCommerceV2_UpdateSaleTitleArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCommerceV2_UpdateSaleVisibleProductIdsArgs = {
  id: Scalars['ID']['input'];
  visibleProductIds: Array<Scalars['ID']['input']>;
};


export type MutationContentReportArgs = {
  input: ContentReportInput;
};


export type MutationCreateConnectionRequestArgs = {
  channelId: Scalars['String']['input'];
  shopDomain: Scalars['String']['input'];
};


export type MutationCreateConnectionRequestV2Args = {
  shopDomain: Scalars['String']['input'];
};


export type MutationCreateSaleArgs = {
  sale: CreateSaleInput;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeactivateSaleArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAllSalesOnShopArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteConnectionArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteConnectionV2Args = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCustomCommissionPolicyForShopArgs = {
  shopDomain: Scalars['String']['input'];
};


export type MutationDeleteSaleArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDisablePluginsArgs = {
  command: DisablePluginsInput;
};


export type MutationEnablePluginsArgs = {
  command: EnablePluginsInput;
};


export type MutationFeatureCollectionArgs = {
  collectionId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationFeatureProductArgs = {
  productId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationProductsAddedToCartArgs = {
  productId: Scalars['ShopifyProductID']['input'];
  quantity: Scalars['Int']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  variantId: Scalars['ShopifyProductVariantID']['input'];
};


export type MutationSetHideShopMiniEntrypointOnBroadcastEndArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetOnboardingStateArgs = {
  onboardingState: OnboardingStateInput;
};


export type MutationSetShopMiniEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetShopMiniPushNotificationsEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationTarget_CreateCartArgs = {
  items: Array<Target_CreateCartInput>;
};


export type MutationTriggerShopMiniCleanupJobForShopArgs = {
  shopDomain: Scalars['String']['input'];
};


export type MutationUpdateCollectionVisibilityArgs = {
  collectionId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  visible: Scalars['Boolean']['input'];
};


export type MutationUpdatePlaybackTimingArgs = {
  position?: InputMaybe<Scalars['Float']['input']>;
  velocity?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdatePluginsArgs = {
  command: UpdatePluginsInput;
};


export type MutationUpdateProductVisibilityArgs = {
  productId: Scalars['String']['input'];
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  visible: Scalars['Boolean']['input'];
};


export type MutationUpdateSaleArgs = {
  sale: UpdateSaleInput;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateShopMiniEntrypointArgs = {
  activeBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  preActiveBackgroundImage?: InputMaybe<Scalars['String']['input']>;
  preActivePrimaryText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateShopPreferencesArgs = {
  preferences: UpdateShopPreferencesInput;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertCustomCommissionPolicyForShopArgs = {
  customCommissionPolicy: UpsertCustomCommissionPolicyInput;
  shopDomain: Scalars['String']['input'];
};


export type MutationVoting_ActivateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationVoting_CastVoteArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
  votes: Array<Voting_VotesInput>;
};


export type MutationVoting_CreateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  question: Voting_CreateQuestionInput;
};


export type MutationVoting_DeactivateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVoting_DeleteQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationVoting_ResetAllVotesArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVoting_ResetVotesArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};


export type MutationVoting_UpdateQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  question: Voting_UpdateQuestionInput;
};

/** Set the onboarding state */
export type OnboardingStateInput = {
  onboardingCompleted: Scalars['Boolean']['input'];
  shopId: Scalars['ID']['input'];
};

export type Order = {
  __typename?: 'Order';
  baseCurrencyCode: Scalars['String']['output'];
  baseDiscountApplied: Scalars['String']['output'];
  baseSubtotal: Scalars['String']['output'];
  baseSubtotalWithoutDiscount: Scalars['String']['output'];
  baseTotal: Scalars['String']['output'];
  cartId: Scalars['ID']['output'];
  commissionPercentage: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  discountApplied: Scalars['String']['output'];
  discountCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced with Order.lineItems */
  items: Array<CheckoutLineItem>;
  lineItems: Array<LineItem>;
  name: Scalars['String']['output'];
  nameIsProfane: Scalars['Boolean']['output'];
  orderId: Scalars['ShopifyOrderID']['output'];
  processedAt: Scalars['DateTime']['output'];
  saleId: Scalars['ID']['output'];
  shopId: Scalars['ID']['output'];
  subtotal: Scalars['String']['output'];
  subtotalWithoutDiscount: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type PaginatedSaleResponse = {
  __typename?: 'PaginatedSaleResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  items: Array<Sale>;
};

/** Represents the timing state of the current video playback. */
export type PlaybackTimingState = {
  __typename?: 'PlaybackTimingState';
  /** The current point of the current video playback, measured in milliseconds since the start of the video. */
  currentPosition: Scalars['Float']['output'];
  /** The starting point of the current video playback, measured in milliseconds since the start of the video. */
  position: Scalars['Float']['output'];
  /** When the timing state was last updated, measured in milliseconds since the epoch. */
  timestamp: Scalars['Float']['output'];
  /** The rate of playback. A value of 1.0 indicates playback at normal speed, while 0 indicates a pause. */
  velocity: Scalars['Float']['output'];
};

/** Represents an instance of Plugin for a Stage TEN Channel or Broadcast */
export type Plugin = {
  __typename?: 'Plugin';
  /** The unique ID of the Stage TEN Broadcast is plugin is active on */
  broadcastId?: Maybe<Scalars['ID']['output']>;
  /** The unique ID of the Stage TEN Channel is plugin is associated with */
  channelId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Replaced with 'persistent' attribute */
  forCurrentBroadcast: Scalars['Boolean']['output'];
  /** The plugin instance's unique ID */
  id: Scalars['ID']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  /** The plugin will stay enabled at the end of the broadcast */
  persistent: Scalars['Boolean']['output'];
  /** The plugin's definition */
  pluginDefinition?: Maybe<PluginDefinition>;
  /** The current state of this plugin */
  state: PluginState;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a Registered Plugin in the STAGE TEN Plugin Registry */
export type PluginDefinition = {
  __typename?: 'PluginDefinition';
  attributes?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultPersistence: Scalars['Boolean']['output'];
  defaultState: PluginState;
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents a list of PluginDefinitions */
export type PluginDefinitionList = {
  __typename?: 'PluginDefinitionList';
  cursor?: Maybe<Scalars['String']['output']>;
  moreData: Scalars['Boolean']['output'];
  pluginDefinitions?: Maybe<Array<PluginDefinition>>;
};

/** Represents an event that happens to a PluginInstance */
export type PluginEvent = {
  __typename?: 'PluginEvent';
  event: Scalars['String']['output'];
  plugin: Plugin;
};

/** Represents a list of PluginInstances */
export type PluginList = {
  __typename?: 'PluginList';
  cursor?: Maybe<Scalars['String']['output']>;
  moreData: Scalars['Boolean']['output'];
  plugins?: Maybe<Array<Plugin>>;
};

/** The state of the plugin */
export enum PluginState {
  Disabled = 'disabled',
  Enabled = 'enabled'
}

export type PrimaryDomain = {
  __typename?: 'PrimaryDomain';
  host: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Product = {
  __typename?: 'Product';
  featuredImage?: Maybe<Image>;
  id: Scalars['String']['output'];
  images: ImageConnection;
  options: Array<ProductOption>;
  priceRangeV2: ProductPriceRangeV2;
  publishedOnCurrentPublication: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalInventory: Scalars['Int']['output'];
  tracksInventory: Scalars['Boolean']['output'];
  variants: ProductVariantConnection;
  vendor: Scalars['String']['output'];
};


export type ProductImagesArgs = {
  first: Scalars['Int']['input'];
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductEligibility = {
  __typename?: 'ProductEligibility';
  productId: Scalars['ShopifyProductID']['output'];
  status: EligibilityStatus;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ProductPriceRangeV2 = {
  __typename?: 'ProductPriceRangeV2';
  maxVariantPrice: MoneyV2;
  minVariantPrice: MoneyV2;
};

export enum ProductSortKeys {
  Id = 'ID',
  Title = 'TITLE'
}

export type ProductVariant = {
  __typename?: 'ProductVariant';
  availableForSale: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  inventoryQuantity?: Maybe<Scalars['Int']['output']>;
  price: Scalars['String']['output'];
  selectedOptions: Array<SelectedOptions>;
  title: Scalars['String']['output'];
};

export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection';
  edges: Array<ProductVariantEdge>;
  pageInfo: PageInfo;
};

export type ProductVariantEdge = {
  __typename?: 'ProductVariantEdge';
  cursor: Scalars['String']['output'];
  node: ProductVariant;
};

export type PurchaseFeedbackPreferences = {
  __typename?: 'PurchaseFeedbackPreferences';
  enabled: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  channel: Channel;
  chat_chatBans: Array<Chat_ChatBan>;
  /** Resolves the Instance associated with the access token and intializes a new Instance if it does not exist */
  chat_instance: Chat_Instance;
  /** Requests access to a channel's public chat */
  chat_publicChatAccess: Chat_GrantResult;
  /** Checks if display name is profane or restricted */
  chat_validateDisplayName: Scalars['Boolean']['output'];
  collections: CollectionConnection;
  commerceV2_instance?: Maybe<CommerceV2_Instance>;
  /** Query a product by its ID */
  commerceV2_product?: Maybe<CommerceV2_Product>;
  /** Query a list of products with a search term */
  commerceV2_products: Array<CommerceV2_Product>;
  /** Query a list of products with their IDs */
  commerceV2_productsByIds: Array<Maybe<CommerceV2_Product>>;
  /** Query a sale by its ID */
  commerceV2_sale?: Maybe<CommerceV2_Sale>;
  /** Query existing sales */
  commerceV2_sales: CommerceV2_SalePage;
  /** @deprecated This can be replaced with a shopByDomain query */
  connectionByShopDomain?: Maybe<Connection>;
  /** Information about a discount by its code */
  discount: Discount;
  /** Retrieve a list of custom commission policies */
  listCustomCommissionPolicies: Array<CustomCommissionPolicy>;
  /** Get the current playback timing state. */
  playbackTiming?: Maybe<PlaybackTimingState>;
  /** Get a plugin instance by its interal UUID */
  plugin?: Maybe<Plugin>;
  /** Get a particular plugin definition by UUID */
  pluginDefinition?: Maybe<PluginDefinition>;
  /** Get a particular plugin definition by unique key */
  pluginDefinitionByKey?: Maybe<PluginDefinition>;
  /** Get a list of available plugins */
  pluginDefinitions?: Maybe<PluginDefinitionList>;
  /** Get a list of the plugins on a particular channel. */
  plugins: PluginList;
  product?: Maybe<Product>;
  products: ProductConnection;
  recording: Recording;
  /** Returns a list of public recording IDs on a Shop */
  recordingIdsByShopDomain: Array<Scalars['ID']['output']>;
  /** Lists recordings for a channel */
  recordings: RecordingPage;
  sale?: Maybe<Sale>;
  saleForRecording?: Maybe<Sale>;
  sales?: Maybe<PaginatedSaleResponse>;
  shop?: Maybe<Shop>;
  shopByChannelId?: Maybe<Shop>;
  shopByDomain?: Maybe<Shop>;
  /** Determines whether products products are eligible to be sold on Shop Mini */
  shopMiniProductEligibilities: Array<ProductEligibility>;
  /** Look up the details of a specific product */
  target_productDetails: Target_ProductDetails;
  /** Perform a keyword search for products */
  target_products: Array<Target_ProductDetails>;
  /** Returns the currently active question. */
  voting_activeQuestion?: Maybe<Voting_Question>;
  /** Resolves the Instance associated with the access token and intializes a new Instance if it does not exist */
  voting_instance: Voting_Instance;
  voting_question?: Maybe<Voting_Question>;
  voting_questionFeed: Voting_QuestionFeed;
  /** @deprecated Paginated endpoint questionFeed is preferred */
  voting_questions: Array<Voting_Question>;
};


export type QueryChannelArgs = {
  id: Scalars['String']['input'];
};


export type QueryChat_ChatBansArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChat_InstanceArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChat_PublicChatAccessArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  requestWritePermission?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChat_ValidateDisplayNameArgs = {
  displayName: Scalars['String']['input'];
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCommerceV2_InstanceArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCommerceV2_ProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommerceV2_ProductsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryCommerceV2_ProductsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCommerceV2_SaleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommerceV2_SalesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConnectionByShopDomainArgs = {
  shopDomain: Scalars['String']['input'];
};


export type QueryDiscountArgs = {
  code: Scalars['String']['input'];
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPluginArgs = {
  id: Scalars['String']['input'];
};


export type QueryPluginDefinitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryPluginDefinitionByKeyArgs = {
  pluginDefinitionKey: Scalars['String']['input'];
};


export type QueryPluginDefinitionsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPluginsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<PluginState>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  sortKey?: InputMaybe<ProductSortKeys>;
};


export type QueryRecordingArgs = {
  channelId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryRecordingIdsByShopDomainArgs = {
  shopDomain: Scalars['String']['input'];
};


export type QueryRecordingsArgs = {
  channelId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySaleArgs = {
  saleId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySaleForRecordingArgs = {
  recordingId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryShopArgs = {
  shopId: Scalars['ID']['input'];
};


export type QueryShopByChannelIdArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryShopByDomainArgs = {
  shopDomain: Scalars['String']['input'];
};


export type QueryShopMiniProductEligibilitiesArgs = {
  productIds: Array<Scalars['ShopifyProductID']['input']>;
};


export type QueryTarget_ProductDetailsArgs = {
  tcin: Scalars['String']['input'];
};


export type QueryTarget_ProductsArgs = {
  searchKeyword: Scalars['String']['input'];
};


export type QueryVoting_ActiveQuestionArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVoting_InstanceArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVoting_QuestionArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryVoting_QuestionFeedArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Voting_QuestionFeedOptions>;
};


export type QueryVoting_QuestionsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};

/** A local cache of a STAGE TEN recording */
export type Recording = {
  __typename?: 'Recording';
  /** Aspect Ratio of recording (16:9 or 9:16) */
  aspectRatio?: Maybe<Scalars['String']['output']>;
  /** ID of Broadcast Recording belongs to */
  broadcastId?: Maybe<Scalars['String']['output']>;
  /** Time recording was created */
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Longer description of recording */
  description?: Maybe<Scalars['String']['output']>;
  /** Total length of recording (in seconds) */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Time recording ends */
  endTime?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Unique Internal ID for recording */
  id: Scalars['ID']['output'];
  /** Whether the recording is published */
  sharedPublicly: Scalars['Boolean']['output'];
  /** Time recording starts */
  startTime?: Maybe<Scalars['DateTimeISO']['output']>;
  /** URL to thumbnail preview */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** User provided recording title */
  title?: Maybe<Scalars['String']['output']>;
  /** Url to obtain untrimmed recording video from HLS */
  untrimmedVodHlsUrl?: Maybe<Scalars['String']['output']>;
  /** Asset version id of untrimmed recording video */
  untrimmedVodVersion?: Maybe<Scalars['String']['output']>;
  /** Time recording was last updated */
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Url to obtain recording video from HLS */
  vodHlsUrl?: Maybe<Scalars['String']['output']>;
};

export type RecordingPage = {
  __typename?: 'RecordingPage';
  /** The current page number */
  currentPage: Scalars['Int']['output'];
  /** Whether there are more recordings to fetch */
  hasMore: Scalars['Boolean']['output'];
  /** The recordings in the page */
  items: Array<Recording>;
  /** The total number of recordings */
  total: Scalars['Int']['output'];
};

export type RecurringApplicationCharge = {
  __typename?: 'RecurringApplicationCharge';
  billingOn?: Maybe<Scalars['String']['output']>;
  cappedAmount?: Maybe<Scalars['Float']['output']>;
};

export type ReturnToShowSignal = {
  __typename?: 'ReturnToShowSignal';
  id: Scalars['String']['output'];
};

export type Sale = {
  __typename?: 'Sale';
  /** The ID of the associated Channel */
  channelId: Scalars['ID']['output'];
  /** Which client this Sale belongs to */
  client: Client;
  /** The collections belonging to the Sale */
  collectionIds: Array<Scalars['String']['output']>;
  collections: Array<Collection>;
  createdAt: Scalars['DateTime']['output'];
  /** A brief description of the sale, used for the overlay asset */
  details?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  /** The user-defined discount code associated with the Sale */
  discountCode?: Maybe<Scalars['String']['output']>;
  /**
   * The discount type of the Sale
   * @deprecated Sales no longer hold specific details about discounts
   */
  discountType?: Maybe<SaleDiscount>;
  /**
   * The value of the discount, if applicable
   * @deprecated Sales no longer hold specific details about discounts
   */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** The currently featured collection */
  featuredCollectionId?: Maybe<Scalars['String']['output']>;
  /** The currently featured product */
  featuredProductId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the Sale is hidden */
  hidden: Scalars['Boolean']['output'];
  /** The ID of the Sale */
  id: Scalars['ID']['output'];
  /** Returns the featured image of the first product in the sale */
  previewImage?: Maybe<Image>;
  /** The products belonging to the Sale */
  productIds: Array<Scalars['String']['output']>;
  products: Array<Product>;
  /** The ID of the associated Shop */
  shopId: Scalars['ID']['output'];
  /** Product IDs which are eligible to be sold via Shop Mini */
  shopMiniEligibleProductIds: Array<Scalars['ShopifyProductID']['output']>;
  /** The internal title of the Sale */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The subset of collections which are visible to viewers */
  visibleCollectionIds: Array<Scalars['String']['output']>;
  /** The subset of products which are visible to viewers */
  visibleProductIds: Array<Scalars['String']['output']>;
};


export type SaleCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type SaleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export enum SaleDiscount {
  FixedAmount = 'fixedAmount',
  FreeShipping = 'freeShipping',
  None = 'none',
  Percentage = 'percentage'
}

export type SaleEvent = {
  __typename?: 'SaleEvent';
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The Sale associated with the event */
  sale: Sale;
  /** The type of the event */
  type: SaleEventType;
};

export enum SaleEventType {
  SaleCreated = 'SALE_CREATED',
  SaleDeleted = 'SALE_DELETED',
  SaleUpdated = 'SALE_UPDATED'
}

/** A local cache of a STAGE TEN scheduled show */
export type ScheduledShow = {
  __typename?: 'ScheduledShow';
  /** Time the scheduled show was created */
  createdAt: Scalars['DateTimeISO']['output'];
  /** Description of the scheduled show */
  description?: Maybe<Scalars['String']['output']>;
  /** Splash image uploaded for the schdeuled show */
  splashImageUrl?: Maybe<Scalars['String']['output']>;
  /** Time the scheduled show will begin */
  startTime: Scalars['DateTimeISO']['output'];
  /** State of the scheduled show */
  state: ScheduledShowState;
  /** Whether the scheduled show will include the ability to tip the streamer */
  tipping: Scalars['Boolean']['output'];
  /** Title of the scheduled show */
  title: Scalars['String']['output'];
  /** Time the scheduled show last updated */
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum ScheduledShowState {
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Featured = 'FEATURED',
  Listed = 'LISTED',
  Live = 'LIVE',
  PastDate = 'PAST_DATE',
  Unlisted = 'UNLISTED'
}

export type SelectedOptions = {
  __typename?: 'SelectedOptions';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Represents a Shopify store */
export type Shop = {
  __typename?: 'Shop';
  activeSale?: Maybe<Sale>;
  activeSaleId?: Maybe<Scalars['ID']['output']>;
  /** The affiliate associated with a channel currently connected to the shop */
  affiliate?: Maybe<Affiliate>;
  appHandle: Scalars['String']['output'];
  /** The URL of the App's home page */
  appUrl?: Maybe<Scalars['String']['output']>;
  availableProductCount: Scalars['Int']['output'];
  channelId?: Maybe<Scalars['ID']['output']>;
  connected: Scalars['Boolean']['output'];
  /** @deprecated Replaced with Shop.channelId and Shop.connected */
  connection?: Maybe<Connection>;
  createdAt?: Maybe<Scalars['DateScalar']['output']>;
  /** @deprecated Replaced with Shop.shopDetails.currencyCode */
  currencyCode?: Maybe<Scalars['String']['output']>;
  /** Represents the current commission policy */
  currentCommissionPolicy: CommissionPolicy;
  /** Represents the custom commission policy (if one exists) */
  customCommissionPolicy?: Maybe<CustomCommissionPolicy>;
  /** Represents the default commission policy */
  defaultCommissionPolicy: CommissionPolicy;
  /** The broadcast-viewer embed URL of the channel */
  embedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShopOwner: Scalars['Boolean']['output'];
  needsReauthorization: Scalars['Boolean']['output'];
  onboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  preferences: ShopPreferences;
  publicationId: Scalars['String']['output'];
  recurringApplicationCharge?: Maybe<RecurringApplicationCharge>;
  saleCount: Scalars['Int']['output'];
  sales: PaginatedSaleResponse;
  shopDetails: ShopDetails;
  shopDomain: Scalars['String']['output'];
  /** State related to the Shop Mini */
  shopMini: ShopMini;
  storefrontAccessToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateScalar']['output']>;
  /** The names of the vendors for products in the shop */
  vendorNames: Array<Scalars['String']['output']>;
  watchUrl?: Maybe<Scalars['String']['output']>;
};


/** Represents a Shopify store */
export type ShopSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type ShopDetails = {
  __typename?: 'ShopDetails';
  checkoutApiSupported: Scalars['Boolean']['output'];
  contactEmail: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  myshopifyDomain: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primaryDomain: PrimaryDomain;
};

export type ShopMini = {
  __typename?: 'ShopMini';
  /** State related to the Shop Mini entrypoint */
  entrypoint: ShopMiniEntrypoint;
  /** Whether this shop is eligible for Shop Mini */
  isEligible: Scalars['Boolean']['output'];
  /** Whether the shop has enabled Shop Mini */
  isEnabled: Scalars['Boolean']['output'];
  shop: Shop;
};

export type ShopMiniEntrypoint = {
  __typename?: 'ShopMiniEntrypoint';
  /** The background image of the Shop Mini entrypoint while in the provided status */
  backgroundImage?: Maybe<Image>;
  /** Whether the entrypoint should be automatically hidden when a broadcast is ended */
  hideOnBroadcastEnd: Scalars['Boolean']['output'];
  /** Whether the Shop Mini entrypoint is visible within the Shop app */
  isVisible: Scalars['Boolean']['output'];
  /** The primary text of the Shop Mini entrypoint while in the provided status */
  primaryText?: Maybe<Scalars['String']['output']>;
  /** The last time a push notification was triggered */
  pushNotificationLastTriggeredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether push notifications should be triggered when a broadcast is started */
  pushNotificationsEnabled: Scalars['Boolean']['output'];
  shop: Shop;
  /** The event date and time of the Shop Mini with respect to broadcast lifecycle */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the Shop Mini with respect to broadcast lifecycle */
  status: ShopMiniState;
};


export type ShopMiniEntrypointBackgroundImageArgs = {
  status: ShopMiniState;
};


export type ShopMiniEntrypointPrimaryTextArgs = {
  status: ShopMiniState;
};

/** The state of the Shop Mini with respect to broadcast lifecycle */
export enum ShopMiniState {
  Active = 'ACTIVE',
  PostActive = 'POST_ACTIVE',
  PreActive = 'PRE_ACTIVE'
}

export type ShopPreferences = {
  __typename?: 'ShopPreferences';
  /** Whether the player should force checkouts to be completed with Shopify's native checkout flow. */
  forceShopifyCheckout: Scalars['Boolean']['output'];
  purchaseFeedback: PurchaseFeedbackPreferences;
  shoutouts: ShoutoutsPreferences;
};

export type ShoutoutsPreferences = {
  __typename?: 'ShoutoutsPreferences';
  enabled: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Emits when attributes of the Shop's active sale have been updated */
  activeSaleUpdated: Sale;
  channelUpdated?: Maybe<Channel>;
  /** An event relating to a chat ban has occurred */
  chat_chatBanEvent: Chat_ChatBanEvent;
  /** Indicates if a GrantResult is updated. */
  chat_grantResultUpdated: Chat_GrantResult;
  /** An event relating to a public chat has occurred */
  chat_publicChatEvent: Chat_ChatEvent;
  /** Indicates that a sale has been activated, modified or deactivated */
  commerceV2_activeSaleUpdated?: Maybe<CommerceV2_Instance>;
  /** A sale has been created, updated or deleted */
  commerceV2_saleEvent: CommerceV2_SaleEvent;
  /** Emits when an order has been created for the given cart */
  orderCreatedForCart: Order;
  /** Emits when an order has been completed through Stage TEN Commerce */
  orderCreatedOnShop: Order;
  /** Subscribe to updates to the playback timing state. */
  playbackTimingUpdated: PlaybackTimingState;
  /** Indicates that an event has happened to a PluginInstance. */
  pluginEvent: PluginEvent;
  recordingUpdated?: Maybe<Recording>;
  /** Emits when a Shop's active sale has changed (ie. Activated or deactivated) */
  saleActivatedOrDeactivated: Shop;
  /** A sale has been created, updated or deleted */
  saleEvent: SaleEvent;
  /** Emits when a Stage TEN channel's connection has been updated (ie. Shop connected or disconnected) */
  shopConnectionForChannelUpdated?: Maybe<Shop>;
  /** Emits when a Shop's connection has been updated (ie. Channel connected or disconnected) */
  shopConnectionUpdated: Shop;
  /** Emits when a Shop's Shop Mini Entrypoint has been updated */
  shopMiniEntrypointUpdated: Shop;
  /** Emits when a viewer clicks the return to show button */
  viewerSignalledReturnToShow: ReturnToShowSignal;
  /** Indicates that the currently active question has been changed. */
  voting_activeQuestionUpdated?: Maybe<Voting_Question>;
  /** Indicates that a Question has been created. */
  voting_questionCreated: Voting_Question;
  /** Indicates that a Question has been deleted. */
  voting_questionDeleted: Voting_Question;
  /** Indicates that the Question or associated Answer data have been updated. */
  voting_questionUpdated: Voting_Question;
};


export type SubscriptionActiveSaleUpdatedArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionChannelUpdatedArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionChat_GrantResultUpdatedArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type SubscriptionCommerceV2_ActiveSaleUpdatedArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOrderCreatedForCartArgs = {
  cartIds: Array<Scalars['ID']['input']>;
};


export type SubscriptionOrderCreatedOnShopArgs = {
  shopId: Scalars['ID']['input'];
};


export type SubscriptionPlaybackTimingUpdatedArgs = {
  maxIntervalMillis?: InputMaybe<Scalars['Float']['input']>;
};


export type SubscriptionPluginEventArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionRecordingUpdatedArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionSaleActivatedOrDeactivatedArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionShopConnectionForChannelUpdatedArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionShopMiniEntrypointUpdatedArgs = {
  shopId: Scalars['ID']['input'];
};


export type SubscriptionViewerSignalledReturnToShowArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SubscriptionVoting_ActiveQuestionUpdatedArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionVoting_QuestionCreatedArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionVoting_QuestionDeletedArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionVoting_QuestionUpdatedArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the items to add to a cart */
export type Target_CreateCartInput = {
  /** The number of items to add */
  quantity: Scalars['Int']['input'];
  /** The TCIN of the item to add */
  tcin: Scalars['String']['input'];
};

/** Target product details */
export type Target_ProductDetails = {
  __typename?: 'Target_ProductDetails';
  description?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tcin: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdatePluginInput = {
  options: Scalars['JSON']['input'];
  /** The unique key for the plugin to update */
  pluginKey: Scalars['String']['input'];
};

export type UpdatePluginsInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  plugins: Array<UpdatePluginInput>;
};

export type UpdatePurchaseFeedbackPreferencesInput = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateSaleInput = {
  collectionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  details?: InputMaybe<Scalars['String']['input']>;
  /** The discount code for the Sale */
  discountCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShopPreferencesInput = {
  forceShopifyCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseFeedback?: InputMaybe<UpdatePurchaseFeedbackPreferencesInput>;
  shoutouts?: InputMaybe<UpdateShoutoutsPreferencesInput>;
};

export type UpdateShoutoutsPreferencesInput = {
  enabled: Scalars['Boolean']['input'];
};

export type UpsertCustomCommissionPolicyInput = {
  /** The commission percentage for the policy */
  commissionPercentage: Scalars['Int']['input'];
  /** A brief description of the custom commission policy */
  description: Scalars['String']['input'];
  /** The date at which the custom commission policy will expire */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A local cache of a STAGE TEN user */
export type User = {
  __typename?: 'User';
  /** URL of the user's avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Display name of the user */
  displayName: Scalars['String']['output'];
  /** ID of the user */
  id: Scalars['ID']['output'];
  /** URL of the user's avatar */
  userLinks?: Maybe<Array<UserLink>>;
  /** Username of the user */
  username: Scalars['String']['output'];
};

/** A local cache of a STAGE TEN user-link */
export type UserLink = {
  __typename?: 'UserLink';
  /** ID of the user */
  id: Scalars['ID']['output'];
  /** Link to Use */
  link: Scalars['String']['output'];
  /** Logo of the user link */
  logo?: Maybe<Scalars['String']['output']>;
  /** Sort position of the link */
  position?: Maybe<Scalars['Int']['output']>;
  /** Title of the user link */
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a possible answer to a question */
export type Voting_Answer = {
  __typename?: 'Voting_Answer';
  /** The timestamp of when this Answer was created */
  createdAt: Scalars['Voting_DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The array index, used for sorting */
  index: Scalars['Int']['output'];
  /** Is this the correct answer for the question */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** The text of the answer to display to the end user */
  text: Scalars['String']['output'];
  /** The timestamp of when this Answer was last updated */
  updatedAt: Scalars['Voting_DateTime']['output'];
  /** The current number of votes for this answer */
  votes: Scalars['Int']['output'];
};

/** Represents the styles for the answer result bars */
export type Voting_AnswerBarStyles = {
  __typename?: 'Voting_AnswerBarStyles';
  backgroundFill: Voting_Fill;
  cornerRadius?: Maybe<Scalars['Float']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  margins: Scalars['Float']['output'];
  padding: Scalars['Float']['output'];
  resultFill: Voting_Fill;
  textFill: Voting_Fill;
  voteDisplayFormat?: Maybe<Scalars['String']['output']>;
};

export type Voting_AnswerBarStylesInput = {
  backgroundFill: Voting_FillInput;
  cornerRadius?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  padding: Scalars['Float']['input'];
  resultFill: Voting_FillInput;
  textFill: Voting_FillInput;
  voteDisplayFormat?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a new answer to be created */
export type Voting_CreateAnswerInput = {
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  votes?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a new question to be created */
export type Voting_CreateQuestionInput = {
  /** The answers for this question */
  answers?: InputMaybe<Array<Voting_CreateAnswerInput>>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: InputMaybe<Scalars['ID']['input']>;
  /** Does this question have a correct answer */
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: InputMaybe<Scalars['Int']['input']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: InputMaybe<Voting_CreateStylesInput>;
  /** The text of the question */
  text: Scalars['String']['input'];
};

export type Voting_CreateStylesInput = {
  answerBarStyles: Array<Voting_AnswerBarStylesInput>;
  name: Scalars['String']['input'];
  promptStyles: Voting_PromptStylesInput;
  resultStyles: Voting_ResultStylesInput;
  version: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/** Represents a fill style */
export type Voting_Fill = {
  __typename?: 'Voting_Fill';
  alpha?: Maybe<Scalars['Float']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
};

export type Voting_FillInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  color?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a Plugin Instance for a given Channel */
export type Voting_Instance = {
  __typename?: 'Voting_Instance';
  activeQuestionId?: Maybe<Scalars['ID']['output']>;
  channelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  questionFeed: Voting_QuestionFeed;
  questions: Array<Voting_Question>;
};


/** Represents a Plugin Instance for a given Channel */
export type Voting_InstanceQuestionFeedArgs = {
  options?: InputMaybe<Voting_QuestionFeedOptions>;
};

/** Represents the prompt style for a question */
export type Voting_PromptStyles = {
  __typename?: 'Voting_PromptStyles';
  backgroundFill: Voting_Fill;
  cornerRadius: Scalars['Float']['output'];
  padding: Scalars['Float']['output'];
  textFill: Voting_Fill;
};

export type Voting_PromptStylesInput = {
  backgroundFill: Voting_FillInput;
  cornerRadius: Scalars['Float']['input'];
  padding: Scalars['Float']['input'];
  textFill: Voting_FillInput;
};

/** Represents a question */
export type Voting_Question = {
  __typename?: 'Voting_Question';
  /** The answers for this question */
  answers: Array<Voting_Answer>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: Maybe<Scalars['ID']['output']>;
  /** The timestamp of when this Question was created */
  createdAt: Scalars['Voting_DateTime']['output'];
  /** Does this question have a correct answer */
  hasCorrectAnswer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** The Instance that this Question is associated with */
  instance?: Maybe<Voting_Instance>;
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: Maybe<Scalars['Int']['output']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: Maybe<Voting_Styles>;
  /** The text of the question */
  text: Scalars['String']['output'];
  /** The timestamp of when this Question was last updated */
  updatedAt: Scalars['Voting_DateTime']['output'];
};

/** Represents a feed of Questions */
export type Voting_QuestionFeed = {
  __typename?: 'Voting_QuestionFeed';
  cursor?: Maybe<Scalars['String']['output']>;
  moreData: Scalars['Boolean']['output'];
  questions: Array<Voting_Question>;
};

/** Pagination options for Question feed */
export type Voting_QuestionFeedOptions = {
  cursor?: InputMaybe<Scalars['Voting_DateTime']['input']>;
  /** Max number of elements per fetch. (Default: 10, Fetch all: -1) */
  limit: Scalars['Int']['input'];
};

/** Represents the styles for the answer result bars */
export type Voting_ResultStyles = {
  __typename?: 'Voting_ResultStyles';
  backgroundFill: Voting_Fill;
  childGaps: Scalars['Float']['output'];
  cornerRadius: Scalars['Float']['output'];
  direction?: Maybe<Scalars['String']['output']>;
  padding: Scalars['Float']['output'];
  topMargin?: Maybe<Scalars['Float']['output']>;
};

export type Voting_ResultStylesInput = {
  backgroundFill: Voting_FillInput;
  childGaps: Scalars['Float']['input'];
  cornerRadius: Scalars['Float']['input'];
  direction: Scalars['String']['input'];
  padding: Scalars['Float']['input'];
  topMargin: Scalars['Float']['input'];
};

/** Represents the Overlay Styles for a question */
export type Voting_Styles = {
  __typename?: 'Voting_Styles';
  answerBarStyles: Array<Voting_AnswerBarStyles>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  promptStyles: Voting_PromptStyles;
  resultStyles: Voting_ResultStyles;
  version: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** Represents an update to a specific answer */
export type Voting_UpdateAnswerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  votes?: InputMaybe<Scalars['Int']['input']>;
};

export type Voting_UpdateQuestionInput = {
  /** The answers for this question */
  answers?: InputMaybe<Array<Voting_UpdateAnswerInput>>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: InputMaybe<Scalars['ID']['input']>;
  /** Does this question have a correct answer */
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: InputMaybe<Scalars['Int']['input']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: InputMaybe<Voting_UpdateStylesInput>;
  /** The text of the question */
  text: Scalars['String']['input'];
};

export type Voting_UpdateStylesInput = {
  answerBarStyles: Array<Voting_AnswerBarStylesInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  promptStyles: Voting_PromptStylesInput;
  resultStyles: Voting_ResultStylesInput;
  version: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Voting_VotesInput = {
  answerId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
};

export type UserLinkFieldsFragment = { __typename?: 'UserLink', id: string, title?: string | null, link: string, position?: number | null, logo?: string | null };

export type UserFieldsFragment = { __typename?: 'User', id: string, username: string, displayName: string, avatarUrl?: string | null, userLinks?: Array<{ __typename?: 'UserLink', id: string, title?: string | null, link: string, position?: number | null, logo?: string | null }> | null };

export type ScheduledShowFieldsFragment = { __typename?: 'ScheduledShow', title: string, description?: string | null, createdAt: any, updatedAt: any, state: ScheduledShowState, startTime: any, splashImageUrl?: string | null, tipping: boolean };

export type ChannelFieldsFragment = { __typename?: 'Channel', id: string, title?: string | null, description?: string | null, slug?: string | null, hlsUrl?: string | null, aspectRatio?: string | null, reconnect?: boolean | null, webrtcUrl?: string | null, broadcastId?: string | null, broadcastStreamToken?: string | null, broadcastTitle?: string | null, broadcastDescription?: string | null, live?: boolean | null, liveSubtitles?: boolean | null, bannerUrl?: string | null, watermarkOnPlayer?: boolean | null, user: { __typename?: 'User', id: string, username: string, displayName: string, avatarUrl?: string | null, userLinks?: Array<{ __typename?: 'UserLink', id: string, title?: string | null, link: string, position?: number | null, logo?: string | null }> | null }, scheduledShows?: Array<{ __typename?: 'ScheduledShow', title: string, description?: string | null, createdAt: any, updatedAt: any, state: ScheduledShowState, startTime: any, splashImageUrl?: string | null, tipping: boolean }> | null };

export type GetChannelQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type GetChannelQuery = { __typename?: 'Query', channel: { __typename?: 'Channel', id: string, title?: string | null, description?: string | null, slug?: string | null, hlsUrl?: string | null, aspectRatio?: string | null, reconnect?: boolean | null, webrtcUrl?: string | null, broadcastId?: string | null, broadcastStreamToken?: string | null, broadcastTitle?: string | null, broadcastDescription?: string | null, live?: boolean | null, liveSubtitles?: boolean | null, bannerUrl?: string | null, watermarkOnPlayer?: boolean | null, user: { __typename?: 'User', id: string, username: string, displayName: string, avatarUrl?: string | null, userLinks?: Array<{ __typename?: 'UserLink', id: string, title?: string | null, link: string, position?: number | null, logo?: string | null }> | null }, scheduledShows?: Array<{ __typename?: 'ScheduledShow', title: string, description?: string | null, createdAt: any, updatedAt: any, state: ScheduledShowState, startTime: any, splashImageUrl?: string | null, tipping: boolean }> | null } };

export type ContentReportMutationVariables = Exact<{
  input: ContentReportInput;
}>;


export type ContentReportMutation = { __typename?: 'Mutation', contentReport: boolean };

export type OnChannelUpdatedSubscriptionVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type OnChannelUpdatedSubscription = { __typename?: 'Subscription', channelUpdated?: { __typename?: 'Channel', id: string, title?: string | null, description?: string | null, slug?: string | null, hlsUrl?: string | null, aspectRatio?: string | null, reconnect?: boolean | null, webrtcUrl?: string | null, broadcastId?: string | null, broadcastStreamToken?: string | null, broadcastTitle?: string | null, broadcastDescription?: string | null, live?: boolean | null, liveSubtitles?: boolean | null, bannerUrl?: string | null, watermarkOnPlayer?: boolean | null, user: { __typename?: 'User', id: string, username: string, displayName: string, avatarUrl?: string | null, userLinks?: Array<{ __typename?: 'UserLink', id: string, title?: string | null, link: string, position?: number | null, logo?: string | null }> | null }, scheduledShows?: Array<{ __typename?: 'ScheduledShow', title: string, description?: string | null, createdAt: any, updatedAt: any, state: ScheduledShowState, startTime: any, splashImageUrl?: string | null, tipping: boolean }> | null } | null };

export type Chat_ChatBansQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type Chat_ChatBansQuery = { __typename?: 'Query', chat_chatBans: Array<{ __typename?: 'Chat_ChatBan', id: string, userId: string, displayName?: string | null, sourceName: string, createdAt: string, expiresAt?: string | null }> };

export type PluginFieldsFragment = { __typename?: 'Plugin', id: string, channelId: string, broadcastId?: string | null, state: PluginState, forCurrentBroadcast: boolean, options?: Record<string, any> | null, createdAt?: string | null, updatedAt?: string | null, pluginDefinition?: { __typename?: 'PluginDefinition', key: string } | null };

export type PluginDefinitionFieldsFragment = { __typename?: 'PluginDefinition', id?: string | null, key: string, attributes?: Record<string, any> | null, createdAt?: string | null, updatedAt?: string | null };

export type PluginsQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type PluginsQuery = { __typename?: 'Query', plugins: { __typename?: 'PluginList', cursor?: string | null, moreData: boolean, plugins?: Array<{ __typename?: 'Plugin', id: string, channelId: string, broadcastId?: string | null, state: PluginState, forCurrentBroadcast: boolean, options?: Record<string, any> | null, createdAt?: string | null, updatedAt?: string | null, pluginDefinition?: { __typename?: 'PluginDefinition', key: string } | null }> | null } };

export type EnablePluginsMutationVariables = Exact<{
  command: EnablePluginsInput;
}>;


export type EnablePluginsMutation = { __typename?: 'Mutation', enablePlugins: Array<{ __typename?: 'Plugin', id: string, channelId: string, broadcastId?: string | null, state: PluginState, forCurrentBroadcast: boolean, options?: Record<string, any> | null, createdAt?: string | null, updatedAt?: string | null, pluginDefinition?: { __typename?: 'PluginDefinition', key: string } | null }> };

export type DisablePluginsMutationVariables = Exact<{
  command: DisablePluginsInput;
}>;


export type DisablePluginsMutation = { __typename?: 'Mutation', disablePlugins: Array<{ __typename?: 'Plugin', id: string, channelId: string, broadcastId?: string | null, state: PluginState, forCurrentBroadcast: boolean, options?: Record<string, any> | null, createdAt?: string | null, updatedAt?: string | null, pluginDefinition?: { __typename?: 'PluginDefinition', key: string } | null }> };

export type OnPluginEventSubscriptionVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type OnPluginEventSubscription = { __typename?: 'Subscription', pluginEvent: { __typename?: 'PluginEvent', event: string, plugin: { __typename?: 'Plugin', id: string, channelId: string, broadcastId?: string | null, state: PluginState, forCurrentBroadcast: boolean, options?: Record<string, any> | null, createdAt?: string | null, updatedAt?: string | null, pluginDefinition?: { __typename?: 'PluginDefinition', key: string } | null } } };

export type RecordingFieldsFragment = { __typename?: 'Recording', id: string, broadcastId?: string | null, startTime?: any | null, endTime?: any | null, duration?: number | null, aspectRatio?: string | null, vodHlsUrl?: string | null, untrimmedVodHlsUrl?: string | null, untrimmedVodVersion?: string | null, sharedPublicly: boolean, title?: string | null, description?: string | null, thumbnailUrl?: string | null };

export type GetRecordingQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  recordingId: Scalars['String']['input'];
}>;


export type GetRecordingQuery = { __typename?: 'Query', recording: { __typename?: 'Recording', id: string, broadcastId?: string | null, startTime?: any | null, endTime?: any | null, duration?: number | null, aspectRatio?: string | null, vodHlsUrl?: string | null, untrimmedVodHlsUrl?: string | null, untrimmedVodVersion?: string | null, sharedPublicly: boolean, title?: string | null, description?: string | null, thumbnailUrl?: string | null } };

export type RecordingsQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecordingsQuery = { __typename?: 'Query', recordings: { __typename?: 'RecordingPage', total: number, hasMore: boolean, currentPage: number, items: Array<{ __typename?: 'Recording', id: string, broadcastId?: string | null, startTime?: any | null, endTime?: any | null, duration?: number | null, aspectRatio?: string | null, vodHlsUrl?: string | null, untrimmedVodHlsUrl?: string | null, untrimmedVodVersion?: string | null, sharedPublicly: boolean, title?: string | null, description?: string | null, thumbnailUrl?: string | null }> } };

export const UserLinkFieldsFragmentDoc = gql`
    fragment UserLinkFields on UserLink {
  id
  title
  link
  position
  logo
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  username
  displayName
  avatarUrl
  userLinks {
    ...UserLinkFields
  }
}
    ${UserLinkFieldsFragmentDoc}`;
export const ScheduledShowFieldsFragmentDoc = gql`
    fragment ScheduledShowFields on ScheduledShow {
  title
  description
  createdAt
  updatedAt
  state
  startTime
  splashImageUrl
  tipping
}
    `;
export const ChannelFieldsFragmentDoc = gql`
    fragment ChannelFields on Channel {
  id
  title
  description
  slug
  hlsUrl
  aspectRatio
  reconnect
  webrtcUrl
  broadcastId
  broadcastStreamToken
  broadcastTitle
  broadcastDescription
  live
  liveSubtitles
  bannerUrl
  watermarkOnPlayer
  user {
    ...UserFields
  }
  scheduledShows {
    ...ScheduledShowFields
  }
}
    ${UserFieldsFragmentDoc}
${ScheduledShowFieldsFragmentDoc}`;
export const PluginFieldsFragmentDoc = gql`
    fragment PluginFields on Plugin {
  id
  pluginDefinition {
    key
  }
  channelId
  broadcastId
  state
  forCurrentBroadcast
  options
  createdAt
  updatedAt
}
    `;
export const PluginDefinitionFieldsFragmentDoc = gql`
    fragment PluginDefinitionFields on PluginDefinition {
  id
  key
  attributes
  createdAt
  updatedAt
}
    `;
export const RecordingFieldsFragmentDoc = gql`
    fragment RecordingFields on Recording {
  id
  broadcastId
  startTime
  endTime
  duration
  aspectRatio
  vodHlsUrl
  untrimmedVodHlsUrl
  untrimmedVodVersion
  sharedPublicly
  title
  description
  thumbnailUrl
}
    `;
export const GetChannelDocument = gql`
    query getChannel($channelId: String!) {
  channel(id: $channelId) {
    ...ChannelFields
  }
}
    ${ChannelFieldsFragmentDoc}`;

/**
 * __useGetChannelQuery__
 *
 * To run a query within a React component, call `useGetChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelQuery(baseOptions: Apollo.QueryHookOptions<GetChannelQuery, GetChannelQueryVariables> & ({ variables: GetChannelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
      }
export function useGetChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
        }
export function useGetChannelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
        }
export type GetChannelQueryHookResult = ReturnType<typeof useGetChannelQuery>;
export type GetChannelLazyQueryHookResult = ReturnType<typeof useGetChannelLazyQuery>;
export type GetChannelSuspenseQueryHookResult = ReturnType<typeof useGetChannelSuspenseQuery>;
export type GetChannelQueryResult = Apollo.QueryResult<GetChannelQuery, GetChannelQueryVariables>;
export const ContentReportDocument = gql`
    mutation contentReport($input: ContentReportInput!) {
  contentReport(input: $input)
}
    `;
export type ContentReportMutationFn = Apollo.MutationFunction<ContentReportMutation, ContentReportMutationVariables>;

/**
 * __useContentReportMutation__
 *
 * To run a mutation, you first call `useContentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentReportMutation, { data, loading, error }] = useContentReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContentReportMutation(baseOptions?: Apollo.MutationHookOptions<ContentReportMutation, ContentReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentReportMutation, ContentReportMutationVariables>(ContentReportDocument, options);
      }
export type ContentReportMutationHookResult = ReturnType<typeof useContentReportMutation>;
export type ContentReportMutationResult = Apollo.MutationResult<ContentReportMutation>;
export type ContentReportMutationOptions = Apollo.BaseMutationOptions<ContentReportMutation, ContentReportMutationVariables>;
export const OnChannelUpdatedDocument = gql`
    subscription onChannelUpdated($channelId: String!) {
  channelUpdated(id: $channelId) {
    ...ChannelFields
  }
}
    ${ChannelFieldsFragmentDoc}`;

/**
 * __useOnChannelUpdatedSubscription__
 *
 * To run a query within a React component, call `useOnChannelUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnChannelUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnChannelUpdatedSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useOnChannelUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnChannelUpdatedSubscription, OnChannelUpdatedSubscriptionVariables> & ({ variables: OnChannelUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnChannelUpdatedSubscription, OnChannelUpdatedSubscriptionVariables>(OnChannelUpdatedDocument, options);
      }
export type OnChannelUpdatedSubscriptionHookResult = ReturnType<typeof useOnChannelUpdatedSubscription>;
export type OnChannelUpdatedSubscriptionResult = Apollo.SubscriptionResult<OnChannelUpdatedSubscription>;
export const Chat_ChatBansDocument = gql`
    query chat_chatBans($channelId: String!) {
  chat_chatBans(channelId: $channelId) {
    id
    userId
    displayName
    sourceName
    createdAt
    expiresAt
  }
}
    `;

/**
 * __useChat_ChatBansQuery__
 *
 * To run a query within a React component, call `useChat_ChatBansQuery` and pass it any options that fit your needs.
 * When your component renders, `useChat_ChatBansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChat_ChatBansQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useChat_ChatBansQuery(baseOptions: Apollo.QueryHookOptions<Chat_ChatBansQuery, Chat_ChatBansQueryVariables> & ({ variables: Chat_ChatBansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Chat_ChatBansQuery, Chat_ChatBansQueryVariables>(Chat_ChatBansDocument, options);
      }
export function useChat_ChatBansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Chat_ChatBansQuery, Chat_ChatBansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Chat_ChatBansQuery, Chat_ChatBansQueryVariables>(Chat_ChatBansDocument, options);
        }
export function useChat_ChatBansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Chat_ChatBansQuery, Chat_ChatBansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Chat_ChatBansQuery, Chat_ChatBansQueryVariables>(Chat_ChatBansDocument, options);
        }
export type Chat_ChatBansQueryHookResult = ReturnType<typeof useChat_ChatBansQuery>;
export type Chat_ChatBansLazyQueryHookResult = ReturnType<typeof useChat_ChatBansLazyQuery>;
export type Chat_ChatBansSuspenseQueryHookResult = ReturnType<typeof useChat_ChatBansSuspenseQuery>;
export type Chat_ChatBansQueryResult = Apollo.QueryResult<Chat_ChatBansQuery, Chat_ChatBansQueryVariables>;
export const PluginsDocument = gql`
    query plugins($channelId: String!, $cursor: String) {
  plugins(channelId: $channelId, cursor: $cursor) {
    cursor
    plugins {
      ...PluginFields
    }
    moreData
  }
}
    ${PluginFieldsFragmentDoc}`;

/**
 * __usePluginsQuery__
 *
 * To run a query within a React component, call `usePluginsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePluginsQuery(baseOptions: Apollo.QueryHookOptions<PluginsQuery, PluginsQueryVariables> & ({ variables: PluginsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PluginsQuery, PluginsQueryVariables>(PluginsDocument, options);
      }
export function usePluginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PluginsQuery, PluginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PluginsQuery, PluginsQueryVariables>(PluginsDocument, options);
        }
export function usePluginsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PluginsQuery, PluginsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PluginsQuery, PluginsQueryVariables>(PluginsDocument, options);
        }
export type PluginsQueryHookResult = ReturnType<typeof usePluginsQuery>;
export type PluginsLazyQueryHookResult = ReturnType<typeof usePluginsLazyQuery>;
export type PluginsSuspenseQueryHookResult = ReturnType<typeof usePluginsSuspenseQuery>;
export type PluginsQueryResult = Apollo.QueryResult<PluginsQuery, PluginsQueryVariables>;
export const EnablePluginsDocument = gql`
    mutation enablePlugins($command: EnablePluginsInput!) {
  enablePlugins(command: $command) {
    ...PluginFields
  }
}
    ${PluginFieldsFragmentDoc}`;
export type EnablePluginsMutationFn = Apollo.MutationFunction<EnablePluginsMutation, EnablePluginsMutationVariables>;

/**
 * __useEnablePluginsMutation__
 *
 * To run a mutation, you first call `useEnablePluginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnablePluginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enablePluginsMutation, { data, loading, error }] = useEnablePluginsMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useEnablePluginsMutation(baseOptions?: Apollo.MutationHookOptions<EnablePluginsMutation, EnablePluginsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnablePluginsMutation, EnablePluginsMutationVariables>(EnablePluginsDocument, options);
      }
export type EnablePluginsMutationHookResult = ReturnType<typeof useEnablePluginsMutation>;
export type EnablePluginsMutationResult = Apollo.MutationResult<EnablePluginsMutation>;
export type EnablePluginsMutationOptions = Apollo.BaseMutationOptions<EnablePluginsMutation, EnablePluginsMutationVariables>;
export const DisablePluginsDocument = gql`
    mutation disablePlugins($command: DisablePluginsInput!) {
  disablePlugins(command: $command) {
    ...PluginFields
  }
}
    ${PluginFieldsFragmentDoc}`;
export type DisablePluginsMutationFn = Apollo.MutationFunction<DisablePluginsMutation, DisablePluginsMutationVariables>;

/**
 * __useDisablePluginsMutation__
 *
 * To run a mutation, you first call `useDisablePluginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePluginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePluginsMutation, { data, loading, error }] = useDisablePluginsMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useDisablePluginsMutation(baseOptions?: Apollo.MutationHookOptions<DisablePluginsMutation, DisablePluginsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisablePluginsMutation, DisablePluginsMutationVariables>(DisablePluginsDocument, options);
      }
export type DisablePluginsMutationHookResult = ReturnType<typeof useDisablePluginsMutation>;
export type DisablePluginsMutationResult = Apollo.MutationResult<DisablePluginsMutation>;
export type DisablePluginsMutationOptions = Apollo.BaseMutationOptions<DisablePluginsMutation, DisablePluginsMutationVariables>;
export const OnPluginEventDocument = gql`
    subscription onPluginEvent($channelId: String!) {
  pluginEvent(channelId: $channelId) {
    event
    plugin {
      ...PluginFields
    }
  }
}
    ${PluginFieldsFragmentDoc}`;

/**
 * __useOnPluginEventSubscription__
 *
 * To run a query within a React component, call `useOnPluginEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnPluginEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPluginEventSubscription({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useOnPluginEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnPluginEventSubscription, OnPluginEventSubscriptionVariables> & ({ variables: OnPluginEventSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnPluginEventSubscription, OnPluginEventSubscriptionVariables>(OnPluginEventDocument, options);
      }
export type OnPluginEventSubscriptionHookResult = ReturnType<typeof useOnPluginEventSubscription>;
export type OnPluginEventSubscriptionResult = Apollo.SubscriptionResult<OnPluginEventSubscription>;
export const GetRecordingDocument = gql`
    query getRecording($channelId: String!, $recordingId: String!) {
  recording(channelId: $channelId, id: $recordingId) {
    ...RecordingFields
  }
}
    ${RecordingFieldsFragmentDoc}`;

/**
 * __useGetRecordingQuery__
 *
 * To run a query within a React component, call `useGetRecordingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordingQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      recordingId: // value for 'recordingId'
 *   },
 * });
 */
export function useGetRecordingQuery(baseOptions: Apollo.QueryHookOptions<GetRecordingQuery, GetRecordingQueryVariables> & ({ variables: GetRecordingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordingQuery, GetRecordingQueryVariables>(GetRecordingDocument, options);
      }
export function useGetRecordingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordingQuery, GetRecordingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordingQuery, GetRecordingQueryVariables>(GetRecordingDocument, options);
        }
export function useGetRecordingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecordingQuery, GetRecordingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecordingQuery, GetRecordingQueryVariables>(GetRecordingDocument, options);
        }
export type GetRecordingQueryHookResult = ReturnType<typeof useGetRecordingQuery>;
export type GetRecordingLazyQueryHookResult = ReturnType<typeof useGetRecordingLazyQuery>;
export type GetRecordingSuspenseQueryHookResult = ReturnType<typeof useGetRecordingSuspenseQuery>;
export type GetRecordingQueryResult = Apollo.QueryResult<GetRecordingQuery, GetRecordingQueryVariables>;
export const RecordingsDocument = gql`
    query recordings($channelId: ID!, $limit: Int!, $offset: Int) {
  recordings(channelId: $channelId, limit: $limit, offset: $offset) {
    items {
      ...RecordingFields
    }
    total
    hasMore
    currentPage
  }
}
    ${RecordingFieldsFragmentDoc}`;

/**
 * __useRecordingsQuery__
 *
 * To run a query within a React component, call `useRecordingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordingsQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useRecordingsQuery(baseOptions: Apollo.QueryHookOptions<RecordingsQuery, RecordingsQueryVariables> & ({ variables: RecordingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecordingsQuery, RecordingsQueryVariables>(RecordingsDocument, options);
      }
export function useRecordingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecordingsQuery, RecordingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecordingsQuery, RecordingsQueryVariables>(RecordingsDocument, options);
        }
export function useRecordingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecordingsQuery, RecordingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecordingsQuery, RecordingsQueryVariables>(RecordingsDocument, options);
        }
export type RecordingsQueryHookResult = ReturnType<typeof useRecordingsQuery>;
export type RecordingsLazyQueryHookResult = ReturnType<typeof useRecordingsLazyQuery>;
export type RecordingsSuspenseQueryHookResult = ReturnType<typeof useRecordingsSuspenseQuery>;
export type RecordingsQueryResult = Apollo.QueryResult<RecordingsQuery, RecordingsQueryVariables>;